// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination .btn.disabled[data-v-3e33a2cc],.pagination .btn[data-v-3e33a2cc]:disabled{border:none;background-color:transparent}", ""]);
// Exports
module.exports = exports;
